import { Badge, Card, Group, Stack, Text } from '@mantine/core'

import { OutsideAnchor } from '#components/OutsideAnchor'
import { useVersionInfo } from '#hooks'

import styles from './LastReleaseCard.module.css'

const formatBuildTime = (buildtime: string) => {
  const date = new Date(buildtime)
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

export const LastReleaseCard = () => {
  const { data: versionInfo } = useVersionInfo()

  const formattedDate = versionInfo?.buildtime
    ? formatBuildTime(versionInfo.buildtime)
    : null

  return (
    <Card classNames={styles} mih={180} miw={200} maw={400} flex="1" w="100%">
      <Stack h="100%" gap={10} justify="space-between">
        <Group justify="space-between" mb={10} wrap="nowrap">
          <Text fw="bold">Latest Release</Text>
          <Badge className={styles.badge} variant="outline" size="lg">
            {versionInfo ? `v${versionInfo.version}` : '...'}
          </Badge>
        </Group>
        <Text c="dimmed" size="sm">
          {formattedDate ?? 'Loading...'}
        </Text>
        <Text>See what&apos;s new and improved in Scripto.</Text>
        <OutsideAnchor
          mt="auto"
          href="https://www.scripto.live/whats-new"
          tracking={{
            source: 'dashboard',
            to: 'release notes',
          }}
        >
          Release Notes
        </OutsideAnchor>
      </Stack>
    </Card>
  )
}
